export default __webpack_public_path__ + "static/media/problema-08.17d265c1.webp";